import Popup from "../popup/index.js";
import ToastComponent from "./toast.js";
import { closeToast, createToast, openToast, resetDefaultToastOptions, setDefaultToastOptions, allowMultiple, } from "./toast.imperative.js";
const Toast = ToastComponent;
Toast.Backdrop = Popup.Backdrop;
Toast.open = openToast;
Toast.loading = createToast("loading");
Toast.success = createToast("success");
Toast.fail = createToast("fail");
Toast.close = closeToast;
Toast.setDefaultOptions = setDefaultToastOptions;
Toast.resetDefaultOptions = resetDefaultToastOptions;
Toast.allowMultiple = allowMultiple;
export default Toast;
